import React from 'react';

import { Container } from './styles';

interface Props {
  error?: string;
}

const ErrorMessage: React.FC<Props> = ({ error }: Props) => {
  return <Container>{error}</Container>;
};

export default ErrorMessage;
